import React from 'react'

class EnabledButtonSaveComponent extends React.Component {
  render () {
    return (
      <div style={styles.buttonContent}>
        {this.props.disabled
          ? <button
            disabled
            style={styles.buttonDisabled}
            type={this.props.type}>
            <span style={styles.label}>{this.props.label}</span>
          </button>
          : <button
            style={styles.button}
            type={this.props.type}>
            <span style={styles.label}>{this.props.label}</span>
          </button>
        }
      </div>
    )
  }
}

const styles = {
  buttonContent: {
    marginTop: '8px',
    float: 'right',
    height: '34px'
  },
  button: {
    cursor: 'pointer',
    marginTop: '4px',
    width: '191px',
    height: '32px',
    marginRight: '6px',
    border: '1px solid transparent',
    borderRadius: '19px',
    backgroundColor: '#7ED321'
  },
  buttonDisabled: {
    cursor: 'pointer',
    marginTop: '4px',
    width: '191px',
    height: '32px',
    marginRight: '6px',
    border: '1px solid transparent',
    borderRadius: '19px',
    backgroundColor: 'grey'
  },
  label: {
    textAlign: 'center',
    color: '#000000',
    fontSize: '13px',
    fontWeight: 500
  },
  icon: {
    float: 'right'
  }
}

export default EnabledButtonSaveComponent
